import type { ModelModality } from "@nexra/contracts";

export type ModelCatalogSearch = {
  q?: string;
  modality?: ModelModality;
  sort?: "name";
  inputTypes?: string[];
  developers?: string[];
};

const modalities = new Set<ModelModality>([
  "language", "embedding", "reranker", "image", "video",
  "audio", "world", "multimodal", "other",
]);

/** The catalog URL owns applied filters; absent values mean no restriction. */
export function modelCatalogSearch(search: Record<string, unknown>): ModelCatalogSearch {
  const list = (value: unknown) => {
    const items = Array.isArray(value) ? value : typeof value === "string" ? [value] : [];
    return [...new Set(items.filter((item): item is string => typeof item === "string").map(item => item.trim()).filter(Boolean))];
  };
  const inputTypes = list(search.inputTypes);
  const developers = list(search.developers);
  return {
    ...(typeof search.q === "string" && search.q ? { q: search.q } : {}),
    ...(typeof search.modality === "string" && modalities.has(search.modality as ModelModality) ? { modality: search.modality as ModelModality } : {}),
    ...(search.sort === "name" ? { sort: "name" as const } : {}),
    ...(inputTypes.length ? { inputTypes } : {}),
    ...(developers.length ? { developers } : {}),
  };
}
